<template>
  <!-- added extra div to be able to specify margins/paddings which wouldn't work at v-tooltip -->
  <div>
    <v-tooltip :disabled="disableTooltip"
               v-model="tooltipVal"
               bottom>
      <template #activator="{ on }">
        <v-avatar v-on="on"
                  :size="avatarSize"
                  :style="{border: '1px solid' + avatarBorderColor}">
          <!-- @slot displaying a v-img inside the v-avatar -->
          <slot :item="item">
            <v-img :src="item.img"
                   :style="avatarImageStyle"
                   contain/>
          </slot>
        </v-avatar>
      </template>
      <span>{{ item.title }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "finAvatar",
  props: {
    /** The object must contain at least an img and a title attribute */
    item: {
      type: Object,
      default() {
        return {}
      },
      required: true
    },
    /** Disables the tooltip, just showing the avatar */
    disableTooltip: {
      type: Boolean,
      default: false
    },
    /** Customizes the avatar size */
    avatarSize: {
      type: Number,
      default: 40
    },
    /** The border color of the avatar */
    avatarBorderColor: {
      type: String,
      default: '#d8d1cc'
    },
    /** Special styling for the avatar image */
    avatarImageStyle: {
      type: String
    }
  },
  data() {
    return {
      // added for jest test, see ArchetypeAvatar.spec.js
      tooltipVal: false,
    }
  }
}
</script>

<style scoped>

</style>
